<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter-Two.html" xml:lang="en-US">
<div class="Basic-Text-Frame-5">
<p class="ch"><a id="Anchor-1">Chapter Two</a></p><a id="Anchor-1">
<p class="body-text-opening">Tucker Lawrence braked his mud-encrusted black pickup truck in front of a small stucco-and-wood house on a quiet neighborhood street on the outskirts of Lubbock, Texas.</p>
<p class="body-text">The home was veiled in darkness. No sounds. No sign of movement, which meant Lauren Hernandez hadn’t heard the news yet. The words that would wreak havoc on her life and rip the heart from her chest.</p>
<p class="body-text">He’d exceeded the speed limits to be the first one here, no easy feat in West Texas, where posted limits were frequently eighty miles per hour with a few stretches at eighty-five. He hadn’t wanted Lauren to hear the tragic truth from a stranger.</p>
<p class="body-text">He’d be letting Rod down if he did.</p>
<p class="body-text">So now he’d be the one to walk up that sidewalk and ring the bell. He’d tell Lauren that the man she loved with all her heart, the father of their three young children, would never come walking through the front door again.</p>
<p class="body-text">He wrapped his hand around the truck’s door handle, but couldn’t bring himself to twist it. Instead he let his head fall to the steering wheel as the heartbreaking images claimed his mind.</p>
<p class="body-text">Six seconds into the ride on the toughest bull to come out of the chute last night. From the crack of the opening gate, Rod was doing everything right. Great technique. Terrific form. Spurring and staying in control of the bucking, twisting, spinning monster of an animal.</p>
<p class="body-text">Two seconds to go when the bull went into a spin that threw Rod from the animal’s back and drew him into the vortex. All Tucker could see from his position behind the chutes was a tangle of hooves and human body as Rod tried to free himself from impending disaster.</p>
<p class="body-text">By the time the bull stamped off, Rod wasn’t moving. He’d died two hours later from trauma to the brain.</p>
<p class="body-text">Rod. Laughing, joking, adrenaline running high a few hours ago. Now he was gone. All because he’d lost a battle of wills with a stupid bull acting on instinct.</p>
<p class="body-text">It wasn’t wholly about the money. Nor the glory. Nor the comradery, though all played a part in the rodeo life. It was the thrill of competition, living on the edge, facing death and never believing you wouldn’t walk away, sore but breathing.</p>
<p class="body-text">Tucker opened the door and stepped out of the truck. Dread tore at his heart anew with each clap of his boots along the cement walk. He’d do what he came for, break the news to Lauren as gently as he could.</p>
<p class="body-text">He wouldn’t even try to convince her the risk had been worth it. He wasn’t sure he believed that himself now. Bull riding had lost its glory when he’d watched his friend Rod take his final breath.</p>
<p class="body-text">But where did a man go when he walked away from the only life he knew?</p>
<p class="pl-title">
</p></a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_Two.vue?ba93d39c